import { Box, styled } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from './wrappers.constants';

export const MaxWidthWrapper = styled(Box, {
  maxWidth: `var(--content-max-width, ${CONTENT_MAX_WIDTH})`,
  margin: '0 auto',
});
